$('tr[role="button"]').on('click', function() {
    var url = this.dataset.href;
    if (url) {
        window.location.href = url;
    }
})